<div class="dialog-main">
    <div class="dialog">
        <div class="mat-dialog-actions" mat-dialog-actions [align]="selectedAlign">
            <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
        <div class="payment-option-selector">
            <h3>SZÁMLA KÉSZÍTÉSE</h3>
            <div class="select">
                <h3>Kérem adja meg a kifizetési módot!</h3>
                <select id="paymentOption" name="paymentOption" [ngStyle]="{ 'font-size': '14px', cursor: 'pointer' }"
                    [(ngModel)]="paymentOption">
                    <option value="CARD">{{ 'paymentOption.' + 'CARD' | translate }}</option>
                    <option value="CASH">{{ 'paymentOption.' + 'CASH' | translate }}</option>
                    <option value="WIRE">{{ 'paymentOption.' + 'WIRE' | translate }}</option>
                </select>
            </div>
            <div class="date">
                <h3>Kérem adja meg a számla kiállításának dátumát!</h3>
                <input class="form-control" id="available" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" placeholder="YYYY-MM-DD"
                    required required title="Enter a date in this formart YYYY-MM-DD" type="date"
                    [(ngModel)]="paymentDate" />
            </div>
        </div>
        <div class="text">
            <h3>Megerősíti a számla elkészítését?</h3>
        </div>
        <div class="back-and-to-buttons">
            <button (click)="closeDialog()">Nem</button>
            <button (click)="createInvoice()">Igen</button>
        </div>
    </div>
</div>